var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/news"}},[_c('div',{attrs:{"id":"home-activity"}},[_vm._v(" Студентське життя ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }